import { Pill } from "@/components/report/atoms";
import { fmtMoney, fmtDate, stageTone } from "@/lib/format";
import { Pencil, Trash2 } from "lucide-react";

export const AccountsTable = ({ rows = [], onEdit, onDelete }) => {
  if (rows.length === 0) {
    return (
      <div className="border border-dashed border-[#262626] rounded-sm p-10 text-center" data-testid="accounts-empty">
        <div className="kpi-label mb-1">/ NO ACTIVITIES LOGGED</div>
        <p className="text-sm text-[#A3A3A3]">Click "Log activity" above to capture the first pitch.</p>
      </div>
    );
  }
  return (
    <div className="border border-[#262626] rounded-sm overflow-x-auto" data-testid="accounts-pipeline-table">
      <table className="w-full text-sm">
        <thead className="bg-[#1F1F1F] sticky top-0">
          <tr>
            {["Account", "BDR", "Stage", "Pitch C", "Pitch S", "Meet", "Opp", "Prop #", "Prop $", "W", "L", "Pipeline $", "Last", "Next step", ""].map((h, i) => (
              <th key={i} className={`text-left px-3 py-2.5 kpi-label whitespace-nowrap ${i >= 3 && i <= 12 ? "text-right" : ""}`}>{h}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          {rows.map((r, i) => (
            <tr key={r.id} className={i % 2 ? "bg-[#0A0A0A]" : "bg-[#141414]"} data-testid={`account-row-${i}`}>
              <td className="px-3 py-2.5 text-white font-display tracking-tight whitespace-nowrap">{r.account_name}</td>
              <td className="px-3 py-2.5 text-[#A3A3A3] whitespace-nowrap">{r.bdr_name}</td>
              <td className="px-3 py-2.5">
                <Pill tone={stageTone(r.stage)}>{r.stage}</Pill>
              </td>
              <td className="px-3 py-2.5 text-right font-mono-data text-[#E5E5E5]">{r.pitch_created_count}</td>
              <td className="px-3 py-2.5 text-right font-mono-data text-[#E5E5E5]">{r.pitch_submitted_count}</td>
              <td className="px-3 py-2.5 text-right font-mono-data text-[#E5E5E5]">{r.meetings_count}</td>
              <td className="px-3 py-2.5 text-right font-mono-data text-[#E5E5E5]">{r.opportunities_count}</td>
              <td className="px-3 py-2.5 text-right font-mono-data text-[#E5E5E5]">{r.proposal_count}</td>
              <td className="px-3 py-2.5 text-right font-mono-data text-[#E5E5E5]">{fmtMoney(r.proposal_value)}</td>
              <td className="px-3 py-2.5 text-right font-mono-data text-[#32D74B]">{r.wins_count}</td>
              <td className="px-3 py-2.5 text-right font-mono-data text-[#FF453A]">{r.losses_count}</td>
              <td className="px-3 py-2.5 text-right font-mono-data text-white">{fmtMoney(r.pipeline_value)}</td>
              <td className="px-3 py-2.5 text-right font-mono-data text-[#A3A3A3] whitespace-nowrap">{fmtDate(r.last_activity_date)}</td>
              <td className="px-3 py-2.5 text-[#A3A3A3] max-w-[200px] truncate" title={r.next_step}>{r.next_step || <span className="text-[#525252]">—</span>}</td>
              <td className="px-3 py-2.5 text-right whitespace-nowrap">
                <button
                  type="button"
                  onClick={() => onEdit?.(r.id)}
                  data-testid={`edit-activity-${i}`}
                  className="p-1.5 rounded-sm hover:bg-[#1F1F1F] text-[#737373] hover:text-white transition-colors"
                  aria-label="Edit"
                ><Pencil className="w-3.5 h-3.5" strokeWidth={1.6}/></button>
                <button
                  type="button"
                  onClick={() => onDelete?.(r.id, r.account_name)}
                  data-testid={`delete-activity-${i}`}
                  className="p-1.5 rounded-sm hover:bg-[#FF453A]/10 text-[#737373] hover:text-[#FF453A] transition-colors ml-1"
                  aria-label="Delete"
                ><Trash2 className="w-3.5 h-3.5" strokeWidth={1.6}/></button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default AccountsTable;
